import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  createMatterIntakeTemplateResponses,
  deleteMatterIntakeTemplateResponse,
  updateMatterIntakeTemplateResponse,
} from "@/lib/data/requests/matters/matter-intake-template-response";
import { queryKeys } from "@/lib/data/static";
import type { APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import type { AxiosError } from "axios";
import { toast } from "react-hot-toast";

export const useCreateMatterIntakeTemplateResponse = ({
  showSuccessToast = true,
}: {
  showSuccessToast?: boolean;
} = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createMatterIntakeTemplateResponses,
    onSuccess: () => {
      if (showSuccessToast) {
        toast.success("Matter intake template response created");
      }
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(
        error,
        "Failed to create matter intake template response",
      );
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
  });
};

export const useUpdateMatterIntakeTemplateResponse = ({
  showSuccessToast = true,
}: {
  showSuccessToast?: boolean;
} = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMatterIntakeTemplateResponse,
    onSuccess: () => {
      if (showSuccessToast) {
        toast.success("Matter intake template response updated");
      }
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(
        error,
        "Failed to update matter intake template response",
      );
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
  });
};

export const useDeleteMatterIntakeTemplateResponse = ({
  showSuccessToast = true,
}: {
  showSuccessToast?: boolean;
} = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteMatterIntakeTemplateResponse,
    onSuccess: () => {
      if (showSuccessToast) {
        toast.success("Matter intake template response deleted");
      }
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(
        error,
        "Failed to delete matter intake template response",
      );
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
  });
};
